
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toArray as toArray_1, singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { OpenToolDeleteDialog } from "../../Tools/Dialogs/ToolDeleteDialog.js";
import { toast } from "react-hot-toast";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { ToolId as ToolId_1 } from "../../Shared/Shared.js";
import { Table } from "../../Widgets/Table/Table.js";
import { empty as empty_1, filter, ofArray, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { Helper_typeToTranslationString } from "../../Shared/Tool.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Table_customPropertyValueDtoColumnDefinitions } from "../../Widgets/CustomProperties.js";

export function ReportView(props) {
    let elems;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setSelectedTableRow = patternInput_1[1];
    const selectedTableRow = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = toList(delay(() => {
        let matchValue;
        return append((matchValue = selectedTableRow, (matchValue == null) ? (empty()) : singleton(createElement(OpenToolDeleteDialog, {
            IsOpen: selectedTableRow != null,
            OnClose: () => {
                setSelectedTableRow(undefined);
            },
            SuccessCallback: () => {
                toast.success(t("general.saved_successfully"));
                setSelectedTableRow(undefined);
            },
            ToolId: new ToolId_1(parse(matchValue.ToolId)),
        }))), delay(() => {
            let TableRows;
            return singleton(createElement(Table, (TableRows = toArray(props.Report), {
                ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("createdAt", "", t("general.created_at"), (row) => (new CellContent(6, [row.CreatedAt])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("date", "", t("general.date"), (row_1) => (new CellContent(6, [row_1.LastEventDate])), "text", "date")), delay(() => append(singleton(new ColumnDefinition$1("eventType", "", t("general.event"), (dto) => {
                    const matchValue_1 = dto.LastEvent;
                    return (matchValue_1 == null) ? (new CellContent(0, ["Kein Event"])) : (new CellContent(0, [t(Helper_typeToTranslationString(matchValue_1))]));
                }, "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("toolType", "", t("general.tool_type"), (row_2) => (row_2.IsToolWithQuantity ? (new CellContent(0, [t("tool.simple_tool")])) : (new CellContent(0, [t("general.tool")]))), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", "", t("general.qr_code"), (row_3) => (new CellContent(0, [row_3.QrCodeIds])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("displayName", "", t("general.tool"), (dto_1) => (new CellContent(2, [dto_1.DisplayName, () => {
                    RouterModule_nav(ofArray(toArray(dto_1.OnClickPath)), 1, 1);
                }])), "text", "button")), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_4) => (new CellContent(0, [row_4.Manufacturer])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("tool.model"), (row_5) => (new CellContent(0, [row_5.Model])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_6) => (new CellContent(0, [row_6.SerialNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_7) => (new CellContent(0, [row_7.InventoryNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("checkNumber", "", t("tool.prinzing.check_number"), (row_8) => (new CellContent(0, [row_8.Checknumber])), "text", "text")), delay(() => append(Table_customPropertyValueDtoColumnDefinitions(filter((propertyConfiguration) => {
                    const matchValue_2 = propertyConfiguration.Visibility;
                    switch (matchValue_2.tag) {
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 12:
                        case 11:
                            return false;
                        default:
                            return true;
                    }
                }, props.PropertyConfigurations), t("tool.custom_properties"), (dto_2) => dto_2.CustomProperties, t), delay(() => singleton(new ColumnDefinition$1("deleteAction", "", t("general.action"), (row_9) => (new CellContent(2, [t("general.delete"), () => {
                    setSelectedTableRow(row_9);
                }])), "text", "text")))))))))))))))))))))))))))),
                Controls: empty_1(),
                Options: {
                    BorderStyle: "full",
                    CSVDownload: true,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["date", "asc"],
                    Fullscreen: false,
                    GlobalSearch: true,
                    RowSelection: "disabled",
                    SaveTableConfiguration: false,
                },
                TableKey: "not-defined-table",
                TableRows: TableRows,
            })));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

